<template>
  <div style="min-width: 1046px">
    <div class="section-right-content-box">
      <div class="box-shadow top-box">
        <div class="global-title cover">
          <span style="padding: 0 28px">客户资产分析</span>
          <el-button class="exportData" @click="exportFn">导出数据</el-button>
        </div>
        <!-- 资产总览 -->
        <div class="pandect">
          <div class="background" style="margin: 16px 0 0">
            <span class="title"></span>&nbsp;
            <span class="tips">客户资产总览</span>
          </div>
          <div class="card">
            <div class="pandect_title">店铺私域人群总数</div>
            <div class="pandect_number">{{ overView.crowdCount | numberThree }}</div>
            <div class="pandect_add">
              较前1日
              <i style="font-size: 20px; vertical-align: middle;" :style="{color: overView.crowdCompareAdd > 0 ? '#FE4D45' : '#49C568'}" :class="overView.crowdCompareAdd > 0 ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
              <span style="margin-left: 60px" :style="{color: overView.crowdCompareAdd > 0 ? '#FE4D45' : '#49C568'}">{{ overView.crowdCompareAdd }}</span>
            </div>
          </div>
          <div class="card">
            <div class="pandect_title">已购客户数</div>
            <div class="pandect_number">{{ overView.purchasedCount | numberThree }}</div>
            <div class="pandect_add">
              较前1日
              <i style="font-size: 20px; vertical-align: middle;" :style="{color: overView.purchasedCompareAdd > 0 ? '#FE4D45' : '#49C568'}" :class="overView.purchasedCompareAdd > 0 ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
              <span style="margin-left: 60px" :style="{color: overView.purchasedCompareAdd > 0 ? '#FE4D45' : '#49C568'}">{{ overView.purchasedCompareAdd }}</span>
            </div>
          </div>
          <div class="card">
            <div class="pandect_title">开卡会员数</div>
            <div class="pandect_number">{{ overView.cardCount | numberThree }}</div>
            <div class="pandect_add">
              较前1日
              <i style="font-size: 20px; vertical-align: middle;" :style="{color: overView.cardCompareAdd > 0 ? '#FE4D45' : '#49C568'}" :class="overView.cardCompareAdd > 0 ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
              <span style="margin-left: 60px" :style="{color: overView.cardCompareAdd > 0 ? '#FE4D45' : '#49C568'}">{{ overView.cardCompareAdd }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-right-content-box" style="min-width: 1046px; height: 930px; padding: 0 26px">
      <div style="margin: 16px 0 2px; position: relative;">
        <el-tabs v-model="choose" @tab-click="changeChoose">
          <el-tab-pane label="客户资产结构" name="first"></el-tab-pane>
          <el-tab-pane label="会员分析" name="second"></el-tab-pane>
        </el-tabs>
      </div>
      <!-- 图表数据 -->
      <div class="charts" v-loading="loading">
        <!-- 客户资产结构 -->
        <div
          class="asset"
          :style="{ opacity: choose === 'first' ? 1 : 0, zIndex: choose === 'first' ? 999 : 0 }"
        >
          <div class="background">
            <span class="title"></span>&nbsp;
            <span class="tips">已未购分析</span>
          </div>
          <div class="content">
            <div class="top" id="buy"></div>
            <div class="bottom">
              <el-table
                :data="buyData"
                border
                :header-cell-style="{ background: '#fafafa', fontWeight: 700 }"
                style="width: 100%"
              >
                <el-table-column prop="type" label="客户类型"> </el-table-column>
                <el-table-column prop="customer" label="客户数"> </el-table-column>
                <el-table-column prop="rate" label="占比"></el-table-column>
                <el-table-column label="已购占比分析">
                  <template slot-scope="scope">
                    {{ !scope.row.analysisRate ? "--" : scope.row.analysisRate }}
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <span class="titiecolor" @click="createCrow(scope.row.type)">生成人群</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="background">
            <span class="title"></span>&nbsp;
            <span class="tips">已未开卡分析</span>
          </div>
          <div class="content">
            <div class="top" id="card"></div>
            <div class="bottom">
              <el-table
                :data="cardData"
                border
                :header-cell-style="{ background: '#fafafa', fontWeight: 700 }"
                style="width: 100%"
              >
                <el-table-column prop="type" label="客户类型"> </el-table-column>
                <el-table-column prop="customer" label="客户数"> </el-table-column>
                <el-table-column prop="rate" label="占比"></el-table-column>
                <el-table-column label="开卡占比分析">
                  <template slot-scope="scope">
                    {{ !scope.row.analysisRate ? "--" : scope.row.analysisRate }}
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <span class="titiecolor" @click="createCrow(scope.row.type)">生成人群</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <!-- 会员分析 -->
        <div class="member" :style="{ opacity: choose === 'second' ? 1 : 0, zIndex: choose === 'second' ? 999 : 0 }">
          <!-- 会员分布 -->
          <div class="background">
            <span class="title"></span>&nbsp;
            <span class="tips">会员分布</span>
          </div>
          <div class="content">
            <div class="top" id="member"></div>
            <div class="bottom">
              <el-table
                :data="memberData"
                border
                :header-cell-style="{ background: '#fafafa', fontWeight: 700 }"
                style="width: 100%"
              >
                <el-table-column prop="type" label="客户类型"> </el-table-column>
                <el-table-column prop="customer" label="客户数"> </el-table-column>
                <el-table-column prop="rate" label="占比"></el-table-column>
                <el-table-column label="开卡占比分析">
                  <template slot-scope="scope">
                    {{ !scope.row.analysisRate ? "--" : scope.row.analysisRate }}
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <span class="titiecolor" @click="createCrow(scope.row.type)">生成人群</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 入会趋势 -->
          <div class="background" style="margin-top: 80px">
            <span class="title"></span>&nbsp;
            <span class="tips">入会趋势分析</span>
          </div>
          <div class="trendDate">
            <el-radio v-model="trendRadio" label="7" @change="trendChooseChange"
              >近7天</el-radio
            >
            <el-radio v-model="trendRadio" label="15" @change="trendChooseChange"
              >近15天</el-radio
            >
            <el-radio v-model="trendRadio" label="30" @change="trendChooseChange"
              >近30天</el-radio
            >
            <div id="trend"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 生成报表 -->
    <generate :control = 'control' 
              v-if="control" 
              @transData="(val) => (control = val)"
              @transData1 = 'getphone1'
              ></generate>
     <!-- 生成人群 -->
    <crowdCreate 
      :isShow.sync="isShowCrowdDialog"
      :crowdTag="crowdTag"
    />

  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import generate from '../../components/generate_report.vue'
import { overView, construction, trends, exportData,exportDataOne } from "@/api/analysis/people-asset";
import crowdCreate from "@/components/crowd-create.vue";
import * as echarts from "echarts";
export default {
  name: "monthly_report",
  data() {
    return {
      crowdTag: "", // 人群标记 
      isShowCrowdDialog: false, // 生成人群弹窗
      control:false,
      trendsChoose: 7,
      overView: {
        crowdCount: 0,
        crowdCompareAdd: 0,
        purchasedCount: 0,
        purchasedCompareAdd: 0,
        cardCount: 0,
        cardCompareAdd: 0,
      }, // 客户资产总览
      buyData: [], // 已未购数据
      buyDataPieBig: [], // 已未购饼图数据-大
      buyDataPieSmall: [], // 已未购饼图数据-小
      cardData: [], // 已未开卡数据
      cardDataPieBig: [], // 已未开卡饼图数据-大
      cardDataPieSmall: [], // 已未开卡饼图数据-小
      memberData: [], // 会员分布数据
      memberDataPieBig: [], // 会员分布饼图数据-大
      memberDataPieSmall: [], // 会员分布饼图数据-小
      trendsX: [], // 入会趋势横坐标
      trendsData: [], // 入会趋势数据
      choose: "first",
      trendRadio: "7",
      loading: true,
      postForm: {
        startDate: "",
        endDate: "",
      },
      mytime: [],
      zxData: {
        timeFlag: [],
        buyerCount: [],
        tradeCount: [],
        payment: [],
        buyerAvgCost: [],
      },
      recordData: [],
      people: 0,
      updataTime: "",
    };
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },

  created() {
    this.loading = true;
    this.getOverView()
    this.getBuyData()
    this.getCardData()
    this.getMemberData()
    this.getTrendsData()

    // 埋点
    this.buriedPoint(1, '客户资产分析', '数据分析', '客户分析')
  },
  components: {
    generate,
    crowdCreate,
  },

  methods: {
    // 生成人群
    createCrow(name) {
      this.filterCrowdTag(name)
      this.isShowCrowdDialog = true
    },

    // 过滤人群标签
    filterCrowdTag(type) {
      switch (type) {
        case "未购": 
          this.crowdTag = "NOT_PURCHASE"
          break
        case "首购": 
          this.crowdTag = "FIRST_PURCHASE"
          break
        case "已购": 
          this.crowdTag = "PURCHASE"
          break
        case "复购": 
          this.crowdTag = "REPURCHASE"
          break
        case "开卡未购": 
          this.crowdTag = "OPEN_CARD_NOT_PUR"
          break
        case "开卡已购": 
          this.crowdTag = "OPEN_CARD_PUR"
          break
        case "未开卡": 
          this.crowdTag = "NOT_OPEN_CARD"
          break
        case "已开卡": 
          this.crowdTag = "CARD"
          break
        case "一星会员": 
          this.crowdTag = "ONE_STAR_LEVEL"
          break
        case "二星会员": 
          this.crowdTag = "TWO_STAR_LEVEL"
          break
        case "三星会员": 
          this.crowdTag = "THREE_STAR_LEVEL"
          break
        case "四星会员": 
          this.crowdTag = "FOUR_STAR_LEVEL"
          break
        case "五星会员": 
          this.crowdTag = "FIVE_STAR_LEVEL"
          break
      }
    },

    // 获取入会趋势数据
    async getTrendsData(type = 7) {
      const { data } = await trends({ type })
      data.forEach((item) => {
        this.trendsX.push(item.dateTime)
        this.trendsData.push(item.num)
      })
      this.drawTrendBar();
    },

    // 获取会员分布数据
    async getMemberData() {
      const { data } = await construction({ type: 3 })
      this.memberData = data
      data.forEach((item) => {
        // 大饼
        if(item.type !== "已开卡") {
          this.memberDataPieBig.push({
            name: item.type,
            value: item.customer
          })
        }
        // 小饼
        if(item.type === "未开卡" || item.type === "已开卡") {
          this.memberDataPieSmall.push({
            name: item.type,
            value: item.customer
          })
        }
      })
      this.drawMemberBar();
    },

    // 获取已未开卡数据
    async getCardData() {
      const { data } = await construction({ type: 2 })
      this.cardData = data
      data.forEach((item) => {
        // 大饼
        if(item.type !== "已开卡") {
          this.cardDataPieBig.push({
            name: item.type,
            value: item.customer
          })
        }
        // 小饼
        if(item.type === "未开卡" || item.type === "已开卡") {
          this.cardDataPieSmall.push({
            name: item.type,
            value: item.customer
          })
        }
      })
      this.drawCardBar();
      if(this.cardData) {
        this.loading = false
      }
    },

    // 获取已未购数据
    async getBuyData() {
      const { data } = await construction({ type: 1 })
      this.buyData = data
      data.forEach((item) => {
        // 大饼
        if(item.type !== "已购") {
          this.buyDataPieBig.push({
            name: item.type,
            value: item.customer
          })
        }
        // 小饼
        if(item.type === "未购" || item.type === "已购") {
          this.buyDataPieSmall.push({
            name: item.type,
            value: item.customer
          })
        }
      })
      this.drawBuyBar();
    },

    // 获取客户资产总览
    async getOverView() {
      const { data } = await overView()
      this.overView = data
    },

    trendChooseChange(val) {
      this.trendsChoose = val
      this.trendsX = []
      this.trendsData = []
      this.trendRadio
      this.getTrendsData(val)
    },

    changeChoose(val) {
      if (val.name === "first") {
        this.isAsset = true;
      } else {
        this.isAsset = false;
      }
    },
    // 导出数据
    async exportFn() {
     this.control = true;
    },
    getphone1(val){  
     let params = {
      type:this.trendsChoose,
      exportRemark:val
     }
     exportDataOne(params).then((res)=>{
        if(res.code==1){
            this.control = true;
        }else{
          this.$message.error(res.message);
        }
      })
    }, 
    //绘制已未购分布图
    drawBuyBar() {
      let chartDom = document.getElementById("buy");
      let myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: "item",
          formatter: '{b}: {c} 人<br/> ({d}%)'
        },
        color:  ['#ff6b6b', '#7f86ea','#adb1ef','#ced1f6'],
        legend: {
          bottom: "60",
          data: [
            "未购",
            "已购",
            "首购",
            "复购",
          ],
          icon: "circle",
          itemWidth: 8,
          itemHeight: 8,
        },
        series: [
          {
            type: "pie",
            radius: ["0", "20%"],
            labelLine: {
              length: 30,
            },
            label: {
              show: false,
            },
            data: this.buyDataPieSmall,
          },
          {
            type: "pie",
            radius: ["30%", "40%"],
            labelLine: {
              length: 30,
            },
            label: {
              show: true,
              formatter: "{b}: {@2012}\n({d}%)",
              color: "#666",
              position: "outer",
              alignTo: "edge",
              margin: document.body.clientWidth > 1440 ? 80 : 10,
            },
            data: this.buyDataPieBig,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    //绘制已未开卡分布图
    drawCardBar() {
      let chartDom = document.getElementById("card");
      let myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: "item",
          formatter: '{b}: {c} 人<br/> ({d}%)'
        },
        color:  ['#ff6b6b', '#7f86ea','#adb1ef','#ced1f6'],
        legend: {
          bottom: "60",
          data: [
            "未开卡",
            "已开卡",
            "开卡已购",
            "开卡未购",
          ],
          icon: "circle",
          itemWidth: 8,
          itemHeight: 8,
        },
        series: [
          {
            type: "pie",
            radius: ["0", "20%"],
            labelLine: {
              length: 30,
            },
            label: {
              show: false,
            },
            data: this.cardDataPieSmall,
          },
          {
            type: "pie",
            radius: ["30%", "40%"],
            labelLine: {
              length: 30,
            },
            label: {
              show: true,
              formatter: "{b}: {@2012}\n({d}%)",
              color: "#666",
              position: "outer",
              alignTo: "edge",
              margin: document.body.clientWidth > 1440 ? 80 : 10,
            },
            data: this.cardDataPieBig,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    //绘制会员分布图
    drawMemberBar() {
      let chartDom = document.getElementById("member");
      let myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: "item",
          formatter: '{b}: {c} 人<br/> ({d}%)'
        },
        color:  ['#ff6b6b', '#7f86ea', '#dde0f8','#c7c9f3', '#b7b9f1', '#9fa3ed', '#7e86ea'],
        legend: {
          bottom: "10",
          data: [
            "未开卡",
            "已开卡",
            "一星会员",
            "二星会员",
            "三星会员",
            "四星会员",
            "五星会员",
          ],
          icon: "circle",
          itemWidth: 8,
          itemHeight: 8,
        },
        series: [
          {
            type: "pie",
            radius: ["0", "20%"],
            labelLine: {
              length: 30,
            },
            label: {
              show: false,
            },
            data: this.memberDataPieSmall,
          },
          {
            type: "pie",
            radius: ["30%", "40%"],
            labelLine: {
              length: 30,
            },
            label: {
              show: true,
              formatter: "{b}: {@2012}\n({d}%)",
              color: "#666",
              position: "outer",
              alignTo: "edge",
              margin: document.body.clientWidth > 1440 ? 80 : 10,
            },
            data: this.memberDataPieBig,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    //绘制入会趋势分析图
    drawTrendBar() {
      let chartDom = document.getElementById("trend");
      let myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: 50,
        },
        xAxis: {
          type: "category",
          data: this.trendsX,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "开卡入会人数",
            data: this.trendsData,
            type: "line",
            labelLine: {
              length: 30,
            },
            itemStyle: {
            normal: {
              color: "#7F85E9",
              lineStyle: {
                  color: "#7F85E9"
                }
              }
            },
            label: {
              backgroundColor: "#F6F8FC",
              borderColor: "#8C8D8E",
              borderWidth: 1,
              borderRadius: 4,
              show: false,
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-tabs__nav {
  padding: 10px 0;
  font-size: 20px;
  white-space: nowrap;
  position: relative;
  -webkit-transition: -webkit-transform .3s;
  transition: -webkit-transform .3s;
  transition: transform .3s;
  transition: transform .3s, -webkit-transform .3s;
  float: left;
  z-index: 2;
}

/deep/.el-tabs__item {
  padding: 0 20px;
  height: 40px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 40px;
  display: inline-block;
  list-style: none;
  font-size: 16px;
  font-weight: 700;
  color: #333333;
  position: relative;
}

/deep/.el-tabs__item.is-active {
    color: #FE4D45;
}

.titiecolor {
  cursor: pointer;
  color: #7f85e9;

  &:hover {
    color: #fe4d45;
  }
}

.section-right-content-box {
  margin-top: 10px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;

  .exportData {
    float: right;
    margin-top: 12px;
    margin-right: 20px;
  }

  .cover {
    padding-left: 0;
  }
}

.background {
  height: 32px;
  background: rgba(250, 250, 250, 1);
  opacity: 1;
  line-height: 32px;
  padding-left: 12px;
  margin-bottom: 26px;
  .title {
    display: inline-block;
    width: 2px;
    height: 14px;
    background: rgba(254, 77, 69, 1);
    opacity: 1;
    border-radius: 3px;
    vertical-align: middle;
  }
  .tips {
    width: 56px;
    height: 20px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    opacity: 1;
    vertical-align: middle;
  }
}

/deep/.el-table--enable-row-transition .el-table__body td {
  height: 40px !important;
}

.trendDate {
  margin: 20px;
}

#trend {
  height: 350px;
  width: 100%;
}

.content {
  display: flex;
  height: 280px;

  .top {
    flex: 2;
    width: 30%;
    height: 400px;
    transform: translate(-20px, -80px);
  }

  .bottom {
    flex: 3;
  }
}

.charts {
  position: relative;
  z-index: 0;

  .asset {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
  }

  .member {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
  }
}

.pandect {
  padding: 0 28px;

  .pandect_title {
    font-size: 16px;
    font-weight: 600;
  }

  .card {
    display: inline-block;
    width: 300px;
    margin: 20px 20px 28px 0;
    padding: 20px 30px;
    border: 1px solid #EEEEEE;

    .pandect_title {
      font-size: 14px;
      color: #666666;
    }

    .pandect_number {
      font-size: 24px;
      font-weight: 700;
      color: #333333;
      margin: 12px 0 24px;
    }

    .pandect_add {
      font-size: 14px;
      color: #333333;
    }
  }
}
</style>
